import { CreateAuthentication } from "@musicaudienceexchange/firebase-auth-ui";

export const { useUser, UserContext, UserProvider } = CreateAuthentication();
